// Global scripts from WP
import Animate from "./modules/Animate";
import Animations from "./modules/Animations";
import LazyLoad from "./modules/LazyLoad";
import Slider from "./modules/components/Slider";
import SubscribeNewsletter from "./modules/components/SubscribeNewsletter";
import MobileMenu from "./modules/MobileMenu";
import MobileVideo from "./modules/components/MobileVideo";
import MediaVideo from "./modules/components/MediaVideo";
import CursorSparkle from "./modules/components/CursorSparkle";
import NewsLoadMore from "./modules/components/NewsLoadMore";
import BackLink from "./modules/components/BackLink";
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
// Init mobile menu
new MobileMenu();
// Init gsap animations
new Animate(); // How to use - look in file
// Init custom animations
new Animations();
// Init lazy loading (must run before Slider so gallery listeners are attached
// before slide-change events fire).
new LazyLoad();
// Init slider components
const sliderComponents = document.querySelectorAll('.slider-default');
sliderComponents.forEach((component) => {
    new Slider(component);
});
// Init subscribe newsletter components
const subscribeNewsletterComponents = document.querySelectorAll('.subscribe-newsletter');
subscribeNewsletterComponents.forEach((component) => {
    new SubscribeNewsletter(component);
});
// Init mobile video
const mobileVideoComponents = document.querySelectorAll('.mobile-video');
mobileVideoComponents.forEach((component) => {
    new MobileVideo(component);
});
// Init media video (with play button overlay)
const mediaVideoComponents = document.querySelectorAll('.media-video.has-background');
mediaVideoComponents.forEach((component) => {
    new MediaVideo(component);
});
// same height elements in closest parent
function setSameHeight(selector) {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;
    elements.forEach((el) => {
        el.style.height = 'auto'; // Reset height
        if (el.offsetHeight > maxHeight) {
            maxHeight = el.offsetHeight;
        }
    });
    elements.forEach((el) => {
        el.style.height = `${maxHeight}px`;
    });
}
document.addEventListener('DOMContentLoaded', () => {
    setSameHeight('.block.products .card-height');
    setSameHeight('.block.drawings .card-height');
});
function equalizeLinkCards() {
    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    const childSelectors = ['.card-media', '.card-content h2', '.card-content p'];
    document.querySelectorAll('.block.link-cards').forEach((block) => {
        const cards = Array.from(block.querySelectorAll('.card-link'));
        // Reset any inline heights from a previous pass before measuring
        cards.forEach((card) => {
            childSelectors.forEach((sel) => {
                card.querySelectorAll(sel).forEach((el) => { el.style.height = ''; });
            });
        });
        if (!isDesktop || cards.length < 2)
            return;
        // Step 1: skip if all cards are already the same overall height
        const cardHeights = cards.map((c) => c.offsetHeight);
        const cardsDiffer = Math.max(...cardHeights) !== Math.min(...cardHeights);
        if (!cardsDiffer)
            return;
        // Step 2: find which child elements vary across cards and equalize only those
        childSelectors.forEach((sel) => {
            const elements = cards
                .map((c) => c.querySelector(sel))
                .filter((el) => el !== null);
            if (elements.length < 2)
                return;
            const heights = elements.map((el) => el.offsetHeight);
            const maxHeight = Math.max(...heights);
            if (maxHeight === Math.min(...heights))
                return;
            elements.forEach((el) => { el.style.height = `${maxHeight}px`; });
        });
    });
}
document.addEventListener('DOMContentLoaded', equalizeLinkCards);
window.addEventListener('resize', equalizeLinkCards);
function setMenuSvgPosition() {
    const activeMenuItem = document.querySelector('header .header-navigation-menu .current-menu-item');
    const menuSvg = document.querySelector('.menu-position svg');
    if (activeMenuItem && menuSvg) {
        const menuItemRect = activeMenuItem.getBoundingClientRect();
        const menuItemLeft = menuItemRect.left + (menuItemRect.width / 2) - 32;
        menuSvg.style.left = `${menuItemLeft}px`;
        addEventListener("load", (event) => {
            menuSvg.classList.add('active');
        });
    }
}
setMenuSvgPosition();
new CursorSparkle();
// Init news load more
const newsBlock = document.querySelector('.block.news');
if (newsBlock) {
    new NewsLoadMore(newsBlock);
}
// Init back link
const backLink = document.querySelector('.content-page__back');
if (backLink) {
    new BackLink(backLink);
}
